/* eslint-disable */
import React, { Component } from 'react';

import arrow from '../../../images/arrow.svg';
import market_info from '../../../images/market_info.svg';
import rebate from '../../../images/rebate.svg';

import Slider from './Slider';

/* Home page */
const Home = () => (
    <div>
      <Slider />
        <div className="container">
          <div className="row">
              <div className="col-xs-12">
                <h1 className="section-heading">What is Binary Options?</h1>
                <p>A binary option is a type of financial option with a fixed payout. The payout is determined at the start before you purchase the trade. If your prediction is correct, you receive the fixed (and stated) payout. If not, you will lose your initial stake and nothing more. It is called a 'binary' option because there can only be two outcomes: you either win or lose.</p>
                <p>Whatever market you trade in, always remember that you're not purchasing the asset itself, but a contract (or 'option') that determines how the asset performs over a period of time. This limits your risk and makes it easy for anyone to start trading.</p>
              </div>
          </div>
          <hr />
          <div className="row text-center">
            <h1 className="section-heading">How to trade Binary Options?</h1>
            <div className="col-xs-12 col-md-4">
              <img className="icon" src={arrow} alt="arrow"/>
              <h3>1. Choose your underlying</h3>
              <p>Choose the asset you wish to trade, such as gold, oil, stocks, or currency pairs.</p>
            </div>
            <div className="col-xs-6 col-md-4">
              <img className="icon" src={market_info} alt="arrow" />
              <h3>2. Choose duration of your trade</h3>
              <p>Choose a contract that runs between 10 seconds and 365 days.</p>
            </div>
            <div className="col-xs-12 col-md-4">
              <img className="icon" src={rebate} alt="arrow" />
              <h3>3. Choose your stake and potential return</h3>
              <p>Specify your payout, which is your potential return if your prediction is correct. 
                br>Our system will proceed to calculate your stake, which is the total cost of purchasing the contract.</p>
            </div>
          </div>
      </div>
    </div>
)

export default Home



// WEBPACK FOOTER //
// ./src/components/pages/Home/Home.js